import React from 'react';
import PropTypes from 'prop-types';

export default function LoadingSpinner({
  diameter,
  color,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="spinner-indeterminate"
      width={diameter}
      viewBox="0 0 100 100"
    >
      <circle
        className="path-indeterminate"
        cx="50"
        cy="50"
        r="25"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2.5"
      />
    </svg>
  );
}

LoadingSpinner.defaultProps = {
  diameter: '210px',
  color: '#1DB954',
};

LoadingSpinner.propTypes = {
  diameter: PropTypes.string,
  color: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/common/LoadingSpinner.js